export const assessmentCountKey = (title) => {
    const name = `${title || ""}`.toLowerCase();
    if (name.includes("hads")) return "hads";
    if (name.includes("eortc")) return "eortc";
    if (name.includes("psqi") || name.includes("pqsi")) return "psqi";
    if (name.includes("kdqol")) return "kdqol";
    return name.split(" ")[0];
};
